import { Link } from "react-router-dom";
import { SignedIn, SignedOut } from "@clerk/clerk-react";

// Landing page Play CTA when Clerk is configured. Routes signed-in
// users to /play and signed-out users to /sign-in. Lives in its own
// module so Landing.tsx doesn't import Clerk hooks in the dev-bypass
// build where <ClerkProvider> isn't mounted (calling Clerk hooks
// outside the provider throws).
export default function LandingPlayLink({ className }: { className?: string }) {
  return (
    <>
      <SignedIn>
        {/* Issue #535: signed-in players land on the world picker
            rather than silently falling through to the engine's boot
            world. */}
        <Link to="/worlds" className={className}>
          Play
        </Link>
      </SignedIn>
      <SignedOut>
        <Link to="/sign-in" className={className}>
          Play
        </Link>
      </SignedOut>
    </>
  );
}
